<template>
    <div class="publication__edit content-width">

        <div class="publication__edit-wrapper">
            <give-away-help-form :server="server"/>
        </div>

        <div class="publication__edit-wrapper">
            <select-location />
        </div>

        <div class="publication__edit-wrapper">
            <publication-slider-gallery />
        </div>

    </div>
</template>

<script>

import StateMixin from "../mixins/StateMixin";

import GiveAwayHelpForm from "./GiveAwayHelpForm";
import SelectLocation from "./SelectLocation";
import PublicationSliderGallery from "./PublicationSliderGallery";

export default {
    name: "GiveAwayHelp",
    props: ['server'],
    mixins: [StateMixin],
    components: { GiveAwayHelpForm, SelectLocation, PublicationSliderGallery },
    methods:{
        handleSliderHeight(){
            this.$parent.handleSliderHeight()
        },

        isValid(){
            const v = this.$children.map( e => {
                return e.isValid();
            } );

            if( v.includes(false) ){
                this.$emit('parent-update', false );
                return false
            }

            this.$emit('parent-update', true );
            return true

        }
    },



}
</script>

<style scoped>

</style>
